// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dashboard_main_tasks{
    display: flex;
    flex-direction: column;
}

.taskList_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.taskList_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.taskList_filter_icon:hover {
    opacity: 1;
}

.taskList_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.taskList_filter_icon--active:hover {
    opacity: 1;
}

.taskList_add_wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.taskList_add_wrapper:hover {
    opacity: 1;
}

.taskList_add_icon {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.taskList_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    white-space: nowrap;
}

.tasks_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 0;
}

.tasks_content {
    display: flex;
    flex-direction: column;
    gap: 0;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-right: 4px;
    background: #FFFFFF;
    border-radius: 8px;
}

.tasks{
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* Scrollbar for tasks content - macOS style */
.tasks_content::-webkit-scrollbar {
    width: 8px;
}

.tasks_content::-webkit-scrollbar-track {
    background: transparent;
}

.tasks_content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    border: 2px solid #FFFFFF;
}

.tasks_content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/taskList/TaskList.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA,8CAA8C;AAC9C;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["\n.dashboard_main_tasks{\n    display: flex;\n    flex-direction: column;\n}\n\n.taskList_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.taskList_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.taskList_filter_icon:hover {\n    opacity: 1;\n}\n\n.taskList_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.taskList_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.taskList_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.taskList_add_wrapper:hover {\n    opacity: 1;\n}\n\n.taskList_add_icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.taskList_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    white-space: nowrap;\n}\n\n.tasks_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 0;\n}\n\n.tasks_content {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n    padding-right: 4px;\n    background: #FFFFFF;\n    border-radius: 8px;\n}\n\n.tasks{\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n/* Scrollbar for tasks content - macOS style */\n.tasks_content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.tasks_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.tasks_content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    border: 2px solid #FFFFFF;\n}\n\n.tasks_content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
